const advanceMethodOptions = [
  {
    value: 'default',
    text: 'Por defecto (avance directo por estado)',
    description: 'Utiliza el método de avance por defecto del sistema.',
  },
  {
    value: 'grouped',
    text: 'Por grupos (agrupación con ponderación)',
    description: 'Agrupa los estados por tipo de avance, permitiendo un control más granular sobre el progreso.',
  }
]

const stateWeightingCriteriaOptions = [
  { // esta primera opcion ya veremos como encaja
    value: 'default',
    text: 'Por defecto (avance directo por estado)',
    description: 'Utiliza el método de avance por defecto del sistema.',
  },
  {
    value: 'proportional',
    text: 'Ponderación proporcional a las unidades',
    description: 'Cada estado recibe un peso en función de cuántas unidades tiene. Refleja el impacto real de cada estado en el total. Útil cuando las unidades varían mucho entre estados.',
  },
  {
    value: 'equal',
    text: 'Ponderación igual para cada estado',
    description: 'Todos los estados tienen el mismo peso, sin importar cuántas unidades tenga cada uno. Útil cuando quieres evaluar el cumplimiento por estado, no por volumen. Sirve en auditorías, calidad, cumplimiento de procesos, etc.',
  },
  {
    value: 'custom',
    text: 'Ponderación personalizada por estado',
    description: 'El usuario define manualmente el peso de cada estado. Útil cuando se requiere flexibilidad total o reflejar prioridades específicas.',
  }
]

const statusesVisibilityOptions = [
  {
    value: 'visible_default',
    text: 'Visible para todos (por defecto)',
    description: 'Cualquier usuario podra ver los estados es por defecto del sistema.',
  },
  {
    value: 'visible_roles',
    text: 'Visibilidad por roles',
    description: 'Los usuarios que tienen el rol podrán ver los estados.',
  },
  {
    value: 'visible_users',
    text: 'Visibilidad por usuarios',
    description: 'Cualquier usuario de podra ver los estados es por defecto del sistema.',
  },
]

const registerMultipleStatusesOptions = [
  {
    value: 'single',
    text: 'Registro único (por defecto)',
    description: 'Solo se permite registrar un estado a la vez. Al seleccionar un nuevo estado, el anterior se reemplaza.',
  },
  {
    value: 'multiple',
    text: 'Registro múltiple',
    description: 'Se permite registrar varios estados simultáneamente. Útil cuando un elemento puede estar en varios estados a la vez.',
  },
]

export { advanceMethodOptions, stateWeightingCriteriaOptions, statusesVisibilityOptions, registerMultipleStatusesOptions }
